import { Grid } from '@material-ui/core'
import { Link } from '@mui/material'
import { useContext } from 'react'
import styled from 'styled-components'
import { Context } from '../../providers/ProjectContextProvider'

const FootContainer = styled.footer`
  background: black;
  padding: 25px 64px;
  color: white;

  font-size: 14px;

  > div {
    flex-grow: 0;
    display: flex;
    align-items: center;
  }

  .copyright {
    flex-grow: 1;
    text-align: left;
  }

  .nav-links {
    text-align: right;

    a {
      color: white;
      margin: 0 10px;
      transition: all 200ms ease-in-out;
      cursor: pointer;

      &:hover {
        color: var(--color-secondary);
        text-decoration: none;
      }
    }
  }

  .social-links {
    margin-left: 30px;
    transition: all 300ms ease-in-out;

    a {
      color: white;
      margin: 0 5px;

      &:hover {
        color: $secondary;
      }
    }
  }

  @media only screen and (max-width: 1280px) {
    .nav-links {
      text-align: right;
    }
  }

  @media only screen and (max-width: 960px) {
    padding: 25px 30px;

    .nav-links,
    .copyright {
      text-align: center;
    }
  }
`

const Footer = () => {
  const { setShowContactSupport } = useContext(Context)

  const date = new Date()

  return (
    <FootContainer>
      <Grid container spacing={2}>
        <Grid item md={6} xs={12} className="copyright">
          © {date.getFullYear()} Hexagon AB and/or its subsidiaries.
        </Grid>

        <Grid item md={6} xs={12} className="nav-links">
          <a
            href="https://www.hexagonmi.com/en-US/about-us/terms-of-use"
            target="_blank"
            rel="noreferrer noopener"
          >
            Terms of use
          </a>
          |
          <a
            href="https://www.hexagonmi.com/en-US/about-us/privacy-policy"
            target="_blank"
            rel="noreferrer noopener"
          >
            Privacy policy
          </a>
          |
          <a
            href="https://www.hexagonmi.com/"
            target="_blank"
            rel="noreferrer noopener"
          >
            Hexagon MI
          </a>
          |
          <Link onClick={() => setShowContactSupport(true)}>
            Contact Support
          </Link>
        </Grid>
      </Grid>
    </FootContainer>
  )
}

export default Footer
